for(let i of document.getElementsByClassName('js-to-top')){
  i.addEventListener('click', (e) => {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
  })
}